import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import axios from 'axios';
import queryString from 'query-string';
import scroll from 'react-scroll/modules/mixins/animate-scroll';
import scroller from 'react-scroll/modules/mixins/scroller';
import VisibilitySensor from 'react-visibility-sensor';
import styles from './index.scss';

import request from '../../../utils/request';
import Breadcrumbs from './component/Breadcrumbs';
import Page from '../../components/Page';
import { withLocaleContext } from '../../hocs/LocaleContext';
import { withNotificationStorageContext } from '../../hocs/NotificationStorage';
import Loader from '../../components/Loader';
import SiteInfoContext from '../../hocs/SiteInfoContext';
import TilesContainer from './component/TilesContainer';
import FeaturesAndBenefits from './component/FeaturesAndBenefits';
import SupportAndServices from './component/SupportAndServices';
import TabsBar from './component/TabsBar';
import BannerContainer from './component/BannerContainer';
// eslint-disable-next-line
// import RecentlyViewedCarousel from './component/RecentlyViewedCarousel';
// import RelatedMedia from './component/RelatedMedia';
import CategoryPageDescription from './parts/CategoryPageDescription';
import Tile from './component/Tile';
import SRPContainer from './component/SPRContainer';
import Container from './component/Container';
import { isNotDesktop } from '../../../utils/resizeObserver';
import StaticNotification from './component/StaticNotification';
import { BREADCRUMB_HEIGHT_ON_MOBILE } from '../../../config/consts';

window.history.scrollRestoration = 'manual';

const RelatedMediaLazy = lazy(() => import('./component/RelatedMedia'));

const getHeaderOffset = () => {
    const headerOffset = document.querySelector('.js-header-apc').offsetHeight * -1;
    return isNotDesktop() ? headerOffset - BREADCRUMB_HEIGHT_ON_MOBILE : headerOffset;
};

const getScrollConfig = () => ({
    duration: 500,
    smooth: true,
    delay: 0,
    offset: getHeaderOffset(), // need to be commented in case release in shadow mode
    // offset: document.querySelector('.js-header-apc').offsetHeight * -1,
});

const { CancelToken } = axios;
let cancelLoadSrpPart;
let cancelLoadMedia;

function makeFakeData(count) {
    return new Array(count).fill({
        name: 'asd',
        imageUrl: '',
        pageUrl: '',
        helpMeChooseEnabled: false,
        childCategoryLinks: new Array(2).fill({
            pageUrl: '...',
            linkType: '...',
            name: 'category name',
            helpMeChooseEnabled: false,
        }),
    });
}
const getParameters = queryString.parse(window.location.search);
class CategoryPage extends Component {
    constructor(props) {
        super(props);

        const pushSiteElement = document.querySelector('#siteId');
        const pushSite = pushSiteElement
            ? pushSiteElement.attributes.siteid.nodeValue
            : 'storeSiteUS';

        this.state = {
            pushSite,
            isLoading: false,
            srp: '',
            srpLoading: false,
            siteInfo: {},
            categoryInfo: null,
            bannerInfo: null,
            hasId: false,
            justAppend: false,
            showTileSkeleton: true,
            isFnbVisible: false,
            notification: null,
            supportLinks: null,
            supportQuickLinksSkeleton: true,
            quickLinks: [],
            relatedMediaData: [],
            map3dPreview: {},
        };
    }

    componentDidMount() {
        this.loadCategoryInfo();
        this.getSRP();
        this.getBanner();
        this.displayFooter();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.url !== this.props.match.url) {
            if (!this.props.match.params.id) {
                this.setState({ bannerInfo: null });
            }
            const [prevId, id] = [
                this.getCategoryID(prevProps.match.params.id),
                this.getCategoryID(this.props.match.params.id),
            ];
            if (prevId !== id) {
                this.setState({ bannerInfo: null });
                this.loadCategoryInfo();
                this.getBanner();
                scroll.scrollToTop(getScrollConfig());
            } else {
                scroller.scrollTo('srpPanel', getScrollConfig());
            }
            this.getSRP();
        } else if (prevProps.location.search !== this.props.location.search) {
            this.getSRP();
            if (!this.state.justAppend) {
                scroller.scrollTo('srpPanel', getScrollConfig());
            }
        }
    }

    scrollToTab = to => {
        let location;
        if (to === 'srp') {
            location = 'srpPanel';
        } else if (to === 'fnb') {
            location = 'fnb';
        } else location = 'support';
        scroller.scrollTo(location, getScrollConfig());
    };

    onVisible = isVisible => {
        this.setState({
            isFnbVisible: isVisible,
        });
    };

    goToHome() {
        const { cc, lc } = this.props;
        this.props.history.push(`/shop/${cc}/${lc}/categories`);
    }

    getCategoryID = initialValue => (initialValue ? initialValue.split(/[^a-z0-9]/)[0] : '');

    toggleComparisonWidget = categoryLevel => {
        const toggler = !(categoryLevel === null);
        if (window.APC_TOGGLE_COMPARISON_BAR !== toggler) {
            window.APC_TOGGLE_COMPARISON_BAR = toggler;
        }
    };

    isItFamilyLevel() {
        const { supercat } = this.props.match.params;
        const depth = this.getDepthOfCategories();
        return (supercat === 'power' && depth === 6) || (supercat !== 'power' && depth === 5);
    }

    getDepthOfCategories() {
        const { cc, lc } = this.props;
        return this.props.match.url.replace(`/shop/${cc}/${lc}/categories`, '').split('/').length;
    }

    loadCategoryInfo = () => {
        const depth = this.getDepthOfCategories();
        const { supercat } = this.props.match.params;
        const navStateID = this.props.match.params.id;
        const navState = this.getCategoryID(navStateID);
        const { search } = this.props.location;
        this.setState({
            isLoading: true,
            showTileSkeleton: (supercat === 'power' && depth < 6) || depth < 5,
            notification: navState ? null : this.state.notification,
            supportQuickLinksSkeleton: true,
            supportLinks: null,
            quickLinks: [],
            relatedMediaData: [],
        });
        Promise.resolve(
            request.get(process.env.API_GET_CATEGORY_INFO, {
                params: {
                    navState,
                    pushSite: this.state.pushSite,
                    skuNotAvailable: queryString.parse(search).skuNotAvailable,
                },
            }),
        )
            .then(({ categoryInfo, notification }) => {
                if (notification) {
                    this.setState({ notification });
                }
                if (categoryInfo.categoryLevel === null && navStateID) {
                    this.goToHome();
                }
                if (categoryInfo.categoryLevel === 'familyCategories') {
                    this.getAdditionalLinks(navState);
                }
                if (categoryInfo.showRelatedMediaSection) {
                    this.getRelatedMedia();
                }
                this.setState({
                    categoryInfo,
                    isLoading: false,
                });
                this.toggleComparisonWidget(categoryInfo.categoryLevel);
            })
            .catch(err => {
                console.error('Error loading: ', err);
                this.setState({
                    isLoading: false,
                });
            });
    };

    getRelatedMedia() {
        if (cancelLoadMedia) {
            cancelLoadMedia();
        }
        axios
            .get(
                `/rest/model/schneider/catalog/CategoryActor/relatedMedia?navState=${this.getCategoryID(
                    this.props.match.params.id,
                )}&pushSite=${this.state.pushSite}`,
                {
                    cancelToken: new CancelToken(c => {
                        cancelLoadMedia = c;
                    }),
                },
            )
            .then(response => {
                cancelLoadMedia = null;
                const relatedMediaData = response.data.relatedMedia;
                this.setState({ relatedMediaData });
                const toLoad = relatedMediaData.reduce((toLoadPreview, current) => {
                    if (
                        current.mediaType === '3dModel' &&
                        !this.state.map3dPreview[current.sketchfabId]
                    ) {
                        toLoadPreview.push(current);
                    }
                    return toLoadPreview;
                }, []);
                if (toLoad.length !== 0) {
                    Promise.all(
                        toLoad.map(item =>
                            axios.get(`https://api.sketchfab.com/v3/models/${item.sketchfabId}`),
                        ),
                    ).then(result => {
                        const previewsMap = result.reduce((previews, { data }, index) => {
                            // eslint-disable-next-line no-param-reassign
                            previews[
                                toLoad[index].sketchfabId
                            ] = data.thumbnails.images
                                .sort((a, b) => (a.width > b.width ? -1 : 1))
                                .find(el => el.width < 800).url;
                            return previews;
                        }, {});
                        this.setState({
                            map3dPreview: { ...this.state.map3dPreview, ...previewsMap },
                        });
                    });
                }
            });
    }

    getSRP() {
        const { id } = this.props.match.params;
        const { cc, lc } = this.props;
        this.setState({
            hasId: !!id,
        });
        if (!id) return;
        const requestUrl = `/shop/${cc}/${lc}/search/body/N-${id}${this.props.location.search}`;
        if (cancelLoadSrpPart) {
            cancelLoadSrpPart();
        }
        this.setState({ srpLoading: true }, () => {
            axios
                .get(requestUrl, {
                    cancelToken: new CancelToken(c => {
                        cancelLoadSrpPart = c;
                    }),
                })
                .then(({ data }) => {
                    cancelLoadSrpPart = null;
                    const doc = new DOMParser().parseFromString(data, 'text/html');
                    const srpContainer = doc.querySelectorAll('.js-srp-mediator-inner')[0];
                    if (this.state.justAppend) {
                        const newBannerSrp = doc.querySelector(
                            '.result-list .apc-banner-container',
                        );
                        if (newBannerSrp) {
                            newBannerSrp.parentElement.removeChild(newBannerSrp);
                        }
                        const prevDoc = new DOMParser().parseFromString(
                            this.state.srp,
                            'text/html',
                        );
                        const list = prevDoc.querySelector('.result-list');
                        const additionList = srpContainer.querySelector('.result-list').innerHTML;
                        srpContainer.querySelector(
                            '.pagination-apc__indication-message .search-result-indication-message__quantity_mobile span',
                        ).innerHTML = (+getParameters.No || 0) + 1;
                        srpContainer.querySelector('.result-list').innerHTML =
                            list.innerHTML + additionList;
                    }
                    this.setState({
                        srp: srpContainer.outerHTML,
                        srpLoading: false,
                    });
                })
                .catch(err => {
                    if (!axios.isCancel(err)) {
                        this.setState({
                            srpLoading: false,
                        });
                    }
                });
        });
    }

    getBanner() {
        const { id } = this.props.match.params;

        if (!id) return;

        const navId = this.getCategoryID(id);
        const { cc, lc } = this.props;
        const requestUrl = `/shop/${cc}/${lc}/rest/categories/features/banners/N-${navId}?format=json`;

        axios
            .get(requestUrl)
            .then(({ data }) => {
                this.setState({
                    bannerInfo: { ...data.banner },
                });
            })
            .catch(err => {
                console.error('Error loading: ', err);
            });
    }
    sortByPriority(a, b) {
        if (a.priority === null) {
            return 1;
        } else if (b.priority === null) {
            return -1;
        }
        return a.priority - b.priority;
    }

    displayFooter() {
        window.addEventListener('load', () => {
            const footer = document.querySelector('#category-footer');
            if (footer) {
                footer.style.display = 'block';
            }
        });
    }

    getAdditionalLinks(id) {
        const { cc, lc } = this.props;
        const requestUrl = `/shop/${cc}/${lc}/rest/categories/features/support-links/N-${id}?format=json`;
        axios
            .get(requestUrl)
            .then(({ data }) => {
                let staticLinks = [];
                data.linkGroupContainer.linkGroups.forEach(el => {
                    const links = el.links.filter(link => link.showInQuickLinkSection === true);
                    links.forEach(link => {
                        // eslint-disable-next-line no-param-reassign
                        link.linkGroup = el.nameTag;
                    });
                    staticLinks = staticLinks.concat(links);
                });
                staticLinks = staticLinks.concat(data.linkGroupContainer.pinnedLinks);
                staticLinks.sort(this.sortByPriority);
                this.setState({
                    supportLinks: data.linkGroupContainer.linkGroups.length
                        ? data.linkGroupContainer.linkGroups
                        : null,
                    supportQuickLinksSkeleton: false,
                    quickLinks: staticLinks,
                });
            })
            .catch(err => {
                console.error('Error loading: ', err);
                this.setState({
                    supportQuickLinksSkeleton: false,
                });
            });
    }

    changeApp = (url, justAppend) => {
        const { cc, lc } = this.props;

        this.setState({
            justAppend,
        });
        if (url.indexOf('N-') !== -1) {
            this.props.history.push(`/shop/${cc}/${lc}/categories${url}`);
        } else {
            this.goToHome();
        }
    };

    renderTiles(cardsArray) {
        const { translations } = this.state.categoryInfo;

        return (
            !!cardsArray.length && (
                <TilesContainer>
                    {cardsArray.map((item, i) => (
                        <Tile
                            skeleton={this.state.isLoading}
                            key={`tile-${this.state.isLoading ? 'fake-' : ''}${i}`}
                            data={item}
                            helpMeChoose={translations.helpMeChoose}
                        />
                    ))}
                </TilesContainer>
            )
        );
    }

    render() {
        const { srp, srpLoading, bannerInfo, supportLinks, quickLinks } = this.state;
        const categoryPageClasses = classNames({
            [styles.CategoryPageContent]: true,
            apcCategories: true,
        });
        const srpPanelClasses = classNames({
            [styles.srpPanel]: true,
            [styles.srpPanelLoader]: srpLoading,
        });
        const { categoryInfo } = this.state;
        if (!categoryInfo) {
            return this.state.isLoading ? (
                <Page className={styles.CategoryPage}>
                    <Loader contentBlock={true} />
                </Page>
            ) : null;
        }
        const {
            pageTabTitle,
            breadcrumbs,
            title,
            badge,
            description,
            longDescription,
            imageUrl,
            childCategoryCards,
            topPageLinks,
            translations,
            range,
            categoryLevel,
            featureGroups,
            categoryLevelTag,
            titleTag,
        } = categoryInfo;
        return (
            <SiteInfoContext.Provider value={this.state.siteInfo}>
                <Helmet>
                    <title>{pageTabTitle}</title>
                </Helmet>
                <Page className={styles.CategoryPage} noPadding={true}>
                    <div
                        className={categoryPageClasses}
                        data-category={categoryLevelTag}
                        data-root-category={categoryLevel}
                        data-category-name={titleTag}
                    >
                        <Breadcrumbs
                            breadcrumbs={[...breadcrumbs, { displayName: title }]}
                            external={1}
                        />
                        <CategoryPageDescription
                            skeleton={this.state.isLoading}
                            skeletonDescription={!this.state.showTileSkeleton}
                            skeletonSmallDescription={
                                window.location.toString().indexOf('N-') !== -1
                            }
                            quickLinkSkeleton={
                                !this.state.showTileSkeleton && this.state.supportQuickLinksSkeleton
                            }
                            quickLinks={
                                this.isItFamilyLevel() &&
                                categoryLevel === 'familyCategories' &&
                                quickLinks
                            }
                            descriptionData={{
                                title,
                                badge,
                                description,
                                longDescription,
                                imageUrl,
                                topPageLinks,
                                range,
                                categoryLevel,
                            }}
                        />
                        {this.state.notification ? (
                            <Container>
                                <StaticNotification {...this.state.notification} />
                            </Container>
                        ) : null}
                        {bannerInfo && (
                            <BannerContainer data={bannerInfo} extendClass={styles.bannerImg} />
                        )}
                        {this.state.isLoading
                            ? this.state.showTileSkeleton && this.renderTiles(makeFakeData(4))
                            : this.renderTiles(childCategoryCards)}

                        {this.isItFamilyLevel() &&
                            categoryLevel === 'familyCategories' &&
                            (featureGroups || supportLinks) && (
                                <TabsBar
                                    tabs={translations}
                                    fnb={!!featureGroups}
                                    support={!!supportLinks}
                                    supportSkeleton={this.state.supportQuickLinksSkeleton}
                                    scroll={this.scrollToTab}
                                    isFnbVisible={this.state.isFnbVisible}
                                />
                            )}
                    </div>
                    <div>
                        {this.state.hasId && (
                            <div className={srpPanelClasses} name="srpPanel">
                                <SRPContainer
                                    updateApp={(url, justAppend) => {
                                        this.changeApp(url, justAppend);
                                    }}
                                    srp={srp}
                                />
                                <Loader
                                    shade={true}
                                    top={true}
                                    hide={!srpLoading}
                                    contentBlock={true}
                                    animate={true}
                                />
                            </div>
                        )}
                    </div>
                    <div className="apcCategories">
                        <div className={styles.groups}>
                            {featureGroups &&
                                categoryLevel === 'familyCategories' &&
                                this.isItFamilyLevel() && (
                                    <VisibilitySensor
                                        onChange={this.onVisible}
                                        partialVisibility={true}
                                        minTopValue={150}
                                    >
                                        <FeaturesAndBenefits
                                            data={featureGroups}
                                            header={translations.featuresBenefitTitle}
                                            // needSeparateLine={!!supportLinks}
                                        />
                                    </VisibilitySensor>
                                )}
                            {this.state.categoryInfo.showRelatedMediaSection &&
                                this.state.relatedMediaData.length !== 0 && (
                                    <Suspense
                                        fallback={
                                            <div className={styles.relatedMediaLoading}>
                                                <Loader contentBlock={true} />
                                            </div>
                                        }
                                    >
                                        <RelatedMediaLazy
                                            title={translations.categoryTabRelatedMediaTitle}
                                            data={this.state.relatedMediaData}
                                            map3dPreview={this.state.map3dPreview}
                                            pageTitle={title}
                                        />
                                    </Suspense>
                                )}
                            {supportLinks &&
                                categoryLevel === 'familyCategories' &&
                                this.isItFamilyLevel() && (
                                    <SupportAndServices
                                        data={supportLinks}
                                        header={translations.categoryTabSupportServicesTitle}
                                    />
                                )}
                        </div>
                    </div>
                    {/* <RecentlyViewedCarousel siteId={this.state.pushSite} /> */}
                </Page>
            </SiteInfoContext.Provider>
        );
    }
}

CategoryPage.propTypes = {
    cc: PropTypes.string.isRequired,
    lc: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    notification: PropTypes.shape({
        stack: PropTypes.array.isRequired,
        addNotification: PropTypes.func.isRequired,
        removeNotification: PropTypes.func.isRequired,
    }),
};

export default withLocaleContext(withNotificationStorageContext(CategoryPage));
